import React from 'react'
import s from './VehicleOwnedSwitcher.less'
import SwitchInput from '../utils/SwitchInput'
import T from '../i18n/T'

const VehicleOwnedSwitcher = ({ labelKey, onChange, defaultValue }) => {
  return (
    <div className={s.root}>
      <div>
        <T id={labelKey} />
      </div>
      <SwitchInput onChange={onChange} defaultValue={defaultValue} />
    </div>
  )
}

export default VehicleOwnedSwitcher
